import {
  SET_PARAMETERS,
  ADD_URL_PARAM,
  REPLACE_URL_PARAM,
  SET_REFERENCES,
  SET_USER_VISIBLE_COLUMNS
} from './mutationTypes';

import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';


export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_PARAMETERS](state, urlParameters) {
    state.urlParameters = urlParameters;
  },
  [ADD_URL_PARAM](state, urlParameter) {
    state.urlParameters = [urlParameter, ...state.urlParameters];
  },
  [REPLACE_URL_PARAM](state, urlParam) {
    const index = state.urlParameters.findIndex(u => u.id == urlParam.id);
    if (index >= 0) {
      state.urlParameters.splice(index, 1, urlParam);
    }
  },
  [SET_REFERENCES](state, references) {
    state.references = references;
  },

  [SET_USER_VISIBLE_COLUMNS](state, userVisibleColumns) {
    state.userVisibleColumns = userVisibleColumns;
  }
};